import { types } from "../types/types";

const initialState = {
  cargada: false,
  items: [],
  loading: false,
  error: null,
};

export const aportesPreafiliadoReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.aportesPreafiliadoTraerStart:
      return {
        ...state,
        loading: true,
        error: null,
        cargada: false,
      };
    case types.aportesPreafiliadoTraerSuccess:
      return {
        ...state,
        loading: false,
        items: action.payload,
        cargada: true,
      };
    case types.aportesPreafiliadoTraerError:
      return {
        ...state,
        loading: false,
        error: action.payload,
        items: [],
        cargada: false,
      };
      case types.aportesPreafiliadoLimpiar:
        return {
          loading: false,
          items: [],
          cargada: false,
        };
      case types.aportesPreafiliadoUpdate:
        let array=[];
        
        return {
          ...state,
          items: array
        };
    default:
      return state;
  }
};
